import {usePartnerUi} from "~/contexts/PartnerUiContext";
import {NoticeDialog} from "@bounce/shared/consumer/bounce-ui";
import {IconAlert, Colors} from "@bounce/shared/ui";
import {BounceAddressDetails} from "@bounce/shared/consumer/constants";
import {FormValidations} from "@bounce/shared/consumer/helpers";
import NiceModal from "@ebay/nice-modal-react";
import React from "react";
import {Pages} from "~/bi-events/enum";
import {useWebchat} from "~/components/webchat/useWebchat";
import {useAmplitude} from "~/contexts";

const RescheduleUnavailableDialog = NiceModal.create(() => {
  const {openChat} = useWebchat();
  const {pageClickEvent} = useAmplitude();
  const {whiteLabelEnabled, partnerDetails} = usePartnerUi();

  const phoneNumber = whiteLabelEnabled ? partnerDetails?.phoneNumber : BounceAddressDetails.phone_numbers[0];
  const formattedPhoneNumber = FormValidations.convertInternationalIntoUSFormat(phoneNumber);

  const handleCallUs = () => {
    pageClickEvent({page: Pages.RESCHEDULE_PLAN, cta: "call_us"});
    window.location.href = `tel:${phoneNumber}`;
  };

  const handleOpenChat = () => {
    pageClickEvent({page: Pages.RESCHEDULE_PLAN, cta: "open_chat"});
    openChat({});
  };

  return (
    <NoticeDialog
      title="Your plan can't be rescheduled at this time"
      text={`Call us at ${formattedPhoneNumber} during business hours, or start a chat anytime.`}
      image={<IconAlert height={52} width={52} color={Colors.red._800} />}
      buttonText="Call us"
      onClick={handleCallUs}
      secondaryButtonText="Open chat"
      onClickSecondary={handleOpenChat}
    />
  );
});

export default RescheduleUnavailableDialog;
